/* Drylora storefront. Native Shopify forms remain usable without JavaScript. */
(() => {
  'use strict';
  if (window.dryloraStarted) return;
  window.dryloraStarted = true;
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const routes = JSON.parse($('#drylora-routes')?.textContent || '{}');
  const money = (cents, currency = routes.currency || 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  let returnFocus = null;
  function openDialog(dialog, trigger) {
    if (!dialog?.showModal) return;
    const previous = trigger || document.activeElement;
    $$('dialog[open]').forEach(d => d.close());
    returnFocus = previous;
    dialog.showModal();
  }
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => { if (returnFocus?.isConnected && !returnFocus.closest('dialog:not([open])')) returnFocus.focus({ preventScroll: true }); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  });
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-dialog-close]');
    if (close) close.closest('dialog')?.close();
    const contact = event.target.closest('[data-contact-open]');
    if (contact) openDialog($('[data-contact-dialog]'), contact);
    const unit = event.target.closest('[data-fit-unit]');
    if (unit) {
      const dialog = unit.closest('[data-size-dialog]');
      $$('[data-fit-unit]', dialog).forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
      $$('[data-fit-in]', dialog).forEach(cell => cell.textContent = unit.dataset.fitUnit === 'cm' ? cell.dataset.fitCm : cell.dataset.fitIn);
      $('[data-fit-heading]', dialog).textContent = unit.dataset.fitUnit === 'cm' ? 'Hips (cm)' : 'Hips (in)';
    }
    const size = event.target.closest('[data-size-open]');
    if (size) openDialog($('[data-size-dialog]'), size);
    const cart = event.target.closest('[data-cart-open]');
    if (cart) { event.preventDefault(); openDialog($('[data-cart-dialog]'), cart); refreshCart(); }
  });
  if (location.search.includes('contact_posted=true') || $('#DryloraContact .errors')) openDialog($('[data-contact-dialog]'));
  const cartDialog = $('[data-cart-dialog]');
  const cartStatus = $('[data-cart-status]', cartDialog);
  const nativeCartForm = $('#DryloraCartForm');
  const nativeCartPage = $('.dr-full-cart');
  let cartPending = false, cartUnconfirmed = false, cartReadSequence = 0, nativeCartDirty = false;
  const productStateUpdates = new Set();
  const el = (tag, text, className) => { const node = document.createElement(tag); if (text != null) node.textContent = text; if (className) node.className = className; return node; };
  function syncCartControls() {
    $$('[data-cart-mutation], [data-cart-checkout]', cartDialog).forEach(button => { button.disabled = cartPending || cartUnconfirmed || button.dataset.unavailable === 'true'; });
    cartDialog?.setAttribute('aria-busy', String(cartPending));
    productStateUpdates.forEach(update => update());
  }
  function beginCartMutation() {
    if (cartPending || cartUnconfirmed) return false;
    cartPending = true;
    nativeCartDirty = !!nativeCartPage;
    cartReadSequence++; // An earlier GET must never replace the result of a newer mutation.
    syncCartControls();
    return true;
  }
  function finishCartMutation() {
    cartPending = false; syncCartControls();
    if (nativeCartDirty && !cartDialog.open) location.reload();
  }
  cartDialog?.addEventListener('close', () => {
    if (nativeCartDirty && !cartPending) location.reload();
  });
  function cartButton(label, className) {
    const button = el('button', label, className);
    button.type = 'button'; button.dataset.cartMutation = '';
    return button;
  }
  async function jsonResponse(response) {
    let data;
    try { data = await response.json(); } catch { throw new Error('The store returned an unreadable response. Check your cart before trying again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'That change could not be completed. Please check your cart.');
    return data;
  }
  function bundleFor(item) {
    const config = routes.upsellProduct;
    if (!config || String(item.product_id) !== String(config.id)) return null;
    const variant = config.variants.find(v => String(v.id) === String(item.variant_id || item.id));
    const set = variant?.options[config.optionNames.indexOf('Set')];
    const pieces = { 'Starter Set': { pads: 1, washing: 0, wet: 0 }, 'Everyday Set': { pads: 2, washing: 1, wet: 0 }, 'Complete Set': { pads: 6, washing: 2, wet: 1 } }[set];
    return pieces ? { set, pieces } : null;
  }
  function includedComponents(item, bundle) {
    const group = el('div', null, 'dr-cart-components');
    group.setAttribute('aria-label', `Included in your ${bundle.set}`);
    const labels = { pads: ['Reusable pad', 'Reusable pads'], washing: ['Washing bag', 'Washing bags'], wet: ['Travel wet bag', 'Travel wet bags'] };
    Object.entries(bundle.pieces).forEach(([key, perSet]) => {
      if (!perSet) return;
      const count = perSet * item.quantity, row = el('div', null, 'dr-cart-component');
      const image = el('img'); image.src = routes.accessoryImages?.[key] || routes.productImage; image.alt = labels[key][count === 1 ? 0 : 1]; image.width = 64; image.height = 64; image.loading = 'lazy';
      const body = el('div', null, 'dr-cart-component-body');
      body.append(el('h4', labels[key][count === 1 ? 0 : 1]), el('p', `Included with ${bundle.set}`), el('span', `Quantity: ${count}`, 'dr-cart-component-quantity'));
      row.append(image, body, el('strong', key === 'pads' ? 'Included' : 'FREE', 'dr-cart-component-price'));
      group.append(row);
    });
    return group;
  }
  function renderCart(cart) {
    if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Your cart could not be confirmed.');
    $$('[data-cart-count]').forEach(n => n.textContent = String(cart.item_count));
    const items = $('[data-cart-items]', cartDialog);
    items.replaceChildren();
    $('[data-cart-summary]', cartDialog).hidden = !cart.item_count;
    $('[data-cart-total]', cartDialog).textContent = money(cart.total_price, cart.currency);
    if (!cart.item_count) items.append(el('p', 'Your next routine starts here. Choose a set to make it yours.', 'dr-cart-empty'));
    cart.items.forEach(item => {
      const bundle = bundleFor(item), row = el('article', null, 'dr-cart-item');
      const img = el('img'); img.src = (bundle && routes.bundleImages?.[bundle.set]) || item.featured_image?.url || item.image || routes.productImage; img.alt = bundle && routes.bundleImages?.[bundle.set] ? `${bundle.set} contents shown in Black` : item.featured_image?.alt || item.product_title; img.width = 80; img.height = 80;
      const body = el('div', null, 'dr-cart-item-body');
      const price = el('div', null, 'dr-cart-price'); price.append(el('strong', money(item.final_line_price, cart.currency)));
      if (item.original_line_price > item.final_line_price) {
        price.append(el('s', money(item.original_line_price, cart.currency)));
      }
      body.append(el('h3', item.product_title));
      if (item.variant_title && item.variant_title !== 'Default Title') body.append(el('p', item.variant_title, 'dr-cart-variant'));
      body.append(price);
      if (item.selling_plan_allocation) body.append(el('p', item.selling_plan_allocation.selling_plan.name));
      Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value).forEach(([key, value]) => body.append(el('p', `${key}: ${value}`)));
      const controls = el('div', null, 'dr-cart-line-controls');
      const min = item.quantity_rule?.min || 1, step = item.quantity_rule?.increment || 1;
      const minus = cartButton('−'); minus.setAttribute('aria-label', `Decrease quantity of ${item.variant_title || item.product_title}`);
      const plus = cartButton('+'); plus.setAttribute('aria-label', `Increase quantity of ${item.variant_title || item.product_title}`);
      plus.dataset.unavailable = String(!!item.quantity_rule?.max && item.quantity + step > item.quantity_rule.max);
      const quantity = el('span', String(item.quantity)); quantity.setAttribute('aria-label', 'Quantity');
      const remove = cartButton('Remove'); remove.setAttribute('aria-label', `Remove ${item.variant_title || item.product_title}`);
      minus.addEventListener('click', () => changeCart(item.key, item.quantity - step < min ? 0 : item.quantity - step));
      plus.addEventListener('click', () => changeCart(item.key, item.quantity + step));
      remove.addEventListener('click', () => changeCart(item.key, 0));
      controls.append(minus, quantity, plus, remove); body.append(controls); row.append(img, body);
      if (bundle) row.append(includedComponents(item, bundle));
      items.append(row);
    });
    const offer = $('[data-cart-offer]', cartDialog);
    if (offer) {
      offer.hidden = !cart.items.some(item => bundleFor(item));
      $('[data-cart-offer-title]', offer).textContent = 'Your set. Your extras. All included.';
      $('[data-cart-offer-copy]', offer).textContent = 'The pieces below are included in your bundle price. Free U.S. shipping is included with your set.';
    }
    renderUpgrade(cart);
    renderAccessories(cart);
    syncCartControls();
  }
  async function cartMutation(url, body, loading, success) {
    if (!beginCartMutation()) return;
    const trigger = document.activeElement;
    cartStatus.textContent = loading;
    try {
      const updated = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(jsonResponse);
      if (Array.isArray(updated.items) && Number.isFinite(updated.total_price)) {
        renderCart(updated); cartStatus.textContent = success;
      } else if (!await refreshCart(success, true)) {
        cartStatus.textContent = 'Your item was added, but the cart could not be refreshed. Open the full cart to check your items.';
      }
    } catch (error) {
      // Reconcile with a read only. Never replay a write whose response was lost.
      const confirmed = await refreshCart('', true);
      cartStatus.textContent = confirmed ? `${error.message} Your cart has been refreshed; check its contents before making another change.` : 'We could not confirm the change. Open the full cart before making another change.';
    } finally {
      finishCartMutation();
      if (!trigger?.isConnected) $('[data-dialog-close]', cartDialog)?.focus({ preventScroll: true });
    }
  }
  function renderAccessories(cart) {
    const box = $('[data-cart-recommendations]', cartDialog);
    if (!box) return;
    box.replaceChildren(); box.hidden = true;
    const accessories = (routes.accessories || []).filter(product => !product.requiresPlan && !cart.items.some(item => String(item.product_id) === String(product.id)));
    const list = el('div', null, 'dr-cart-recommendation-list');
    accessories.forEach(product => {
      const variant = product.variants?.find(v => v.available && (!v.max || v.max >= (v.min || 1)));
      if (!variant) return;
      const row = el('article', null, 'dr-cart-recommendation');
      const img = el('img'); img.src = product.image || routes.accessoryImages?.[product.key] || routes.productImage; img.alt = product.title; img.width = 64; img.height = 64; img.loading = 'lazy';
      const body = el('div'), heading = el('h4'), link = el('a', product.title); link.href = product.url;
      heading.append(link); body.append(heading, el('p', money(variant.price, cart.currency)));
      const add = cartButton('Add', 'dr-cart-accessory-add'); add.setAttribute('aria-label', `Add ${product.title} to cart`);
      add.addEventListener('click', () => cartMutation(routes.add, { items: [{ id: variant.id, quantity: variant.min || 1 }] }, `Adding ${product.title}…`, `${product.title} added to your cart.`));
      row.append(img, body, add); list.append(row);
    });
    if (list.childElementCount) {
      box.append(el('h3', 'You might also like'), list); box.hidden = false;
    }
  }
  function renderUpgrade(cart) {
    const box = $('[data-cart-upsell]', cartDialog);
    if (!box) return;
    box.hidden = true; box.replaceChildren();
    const config = routes.upsellProduct;
    if (!config || config.requiresPlan) return;
    const setIndex = config.optionNames.indexOf('Set');
    if (setIndex < 0) return;
    for (const item of cart.items) {
      if (String(item.product_id) !== String(config.id) || item.selling_plan_allocation || Object.values(item.properties || {}).some(Boolean)) continue;
      const source = config.variants.find(v => String(v.id) === String(item.variant_id || item.id));
      if (!source) continue;
      const nextSet = { 'Starter Set': 'Everyday Set', 'Everyday Set': 'Complete Set' }[source.options[setIndex]];
      if (!nextSet) continue;
      const target = config.variants.find(v => v.available && v.options.every((value, index) => value === (index === setIndex ? nextSet : source.options[index])));
      if (!target || target.price <= source.price) continue;
      const existing = cart.items.find(line => String(line.variant_id || line.id) === String(target.id) && !line.selling_plan_allocation && !Object.values(line.properties || {}).some(Boolean));
      const targetQty = item.quantity + (existing?.quantity || 0);
      if (targetQty < target.min || (targetQty - target.min) % target.step || (target.max && targetQty > target.max)) continue;
      const extra = (target.price - source.price) * item.quantity;
      box.append(el('span', 'MORE IN YOUR ROTATION', 'dr-upsell-eyebrow'), el('h3', nextSet === 'Complete Set' ? '4 more pads. 2 more pairs.' : 'Double your Starter pieces.'));
      box.append(el('p', nextSet === 'Complete Set' ? 'Upgrade each set to 6 pairs + 6 pads, with 2 FREE washing bags and a FREE travel wet bag.' : 'Upgrade each set to 4 pairs + 2 pads, with a FREE washing bag.'));
      box.append(el('p', `Same color. Same size. ${money(extra, cart.currency)} more${item.quantity > 1 ? ' for your ' + item.quantity + ' sets' : ''}.`, 'dr-upsell-price'));
      const button = cartButton(`YES, UPGRADE FOR ${money(extra, cart.currency)}`, 'dr-button'); button.dataset.cartUpgrade = '';
      button.addEventListener('click', () => cartMutation(routes.update, { updates: { [item.key]: 0, [existing?.key || String(target.id)]: targetQty } }, 'Upgrading your set…', `You're all set. Your cart now includes the ${nextSet}.`));
      box.append(button); box.hidden = false; break;
    }
  }
  async function refreshCart(message = '', duringMutation = false) {
    if (!window.fetch) { location.href = routes.cart; return false; }
    if (cartPending && !duringMutation) return false;
    const sequence = ++cartReadSequence;
    cartStatus.textContent = message || 'Loading your cart…';
    try {
      const cart = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(jsonResponse);
      if (sequence !== cartReadSequence) return false;
      cartUnconfirmed = false; renderCart(cart); cartStatus.textContent = message;
      return true;
    } catch {
      if (sequence !== cartReadSequence) return false;
      cartUnconfirmed = true; syncCartControls();
      cartStatus.textContent = 'Your cart could not be loaded. Open the full cart to check your items.';
      const link = el('a', 'Open full cart', 'dr-text-link'); link.href = routes.cart;
      $('[data-cart-items]', cartDialog).replaceChildren(link);
      $('[data-cart-summary]', cartDialog).hidden = true;
      $('[data-cart-upsell]', cartDialog).hidden = true;
      if ($('[data-cart-recommendations]', cartDialog)) $('[data-cart-recommendations]', cartDialog).hidden = true;
      return false;
    }
  }
  function changeCart(key, quantity) {
    return cartMutation(routes.change, { id: key, quantity }, 'Updating your cart…', quantity ? 'Cart updated.' : 'Item removed.');
  }
  $('[data-cart-checkout]', cartDialog)?.closest('form')?.addEventListener('submit', event => {
    if (cartPending || cartUnconfirmed) event.preventDefault();
  });
  function isCartURL(href, includeCart = true) {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin) return false;
    const normalize = value => new URL(value, location.origin).pathname.replace(/\.js$/, '');
    const paths = [routes.add, routes.change, routes.update, ...(includeCart ? [routes.cart] : [])].filter(Boolean).map(normalize);
    return paths.includes(normalize(url.href));
  }
  function holdNativeCartChange(event) {
    event.preventDefault(); event.stopImmediatePropagation();
    cartStatus.textContent = 'Your cart is updating. Please wait a moment.';
  }
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.target === nativeCartForm && nativeCartDirty) {
      holdNativeCartChange(event);
      if (!cartPending) location.reload();
    } else if (cartPending && isCartURL(event.target.action)) holdNativeCartChange(event);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !isCartURL(link.href, false)) return;
    if (nativeCartDirty && !cartDialog.contains(link)) {
      holdNativeCartChange(event);
      if (!cartPending) location.reload();
    } else if (cartPending) holdNativeCartChange(event);
  }, true);
  function initProduct(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let slide = 0;
    const slides = $$('[data-slide]', root);
    const surface = $('.dr-gallery-track', root);
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    function markSlide(index) {
      slide = index;
      $$('[data-gallery-select]', root).forEach((button, i) => button.setAttribute('aria-pressed', String(i === slide)));
      const counter = $('[data-gallery-position]', root);
      if (counter) counter.textContent = `${slide + 1} / ${slides.length}`;
      const thumb = $(`[data-gallery-select="${slide}"]`, root), rail = $('.dr-thumbs', root);
      if (thumb && rail) rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + thumb.clientWidth / 2, behavior: reducedMotion() ? 'instant' : 'smooth' });
    }
    function showSlide(index) {
      if (!slides.length || !surface) return;
      const next = (index + slides.length) % slides.length;
      markSlide(next);
      surface.scrollTo({ left: next * surface.clientWidth, behavior: reducedMotion() ? 'instant' : 'smooth' });
    }
    let scrollFrame;
    surface?.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(surface.scrollLeft / surface.clientWidth)));
        if (index !== slide) markSlide(index);
      });
    }, { passive: true });
    if (surface) new ResizeObserver(() => surface.scrollTo({ left: slide * surface.clientWidth, behavior: 'instant' })).observe(surface);
    markSlide(0);
    $('[data-gallery-prev]', root)?.addEventListener('click', () => showSlide(slide - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => showSlide(slide + 1));
    $$('[data-gallery-select]', root).forEach(b => b.addEventListener('click', () => showSlide(Number(b.dataset.gallerySelect))));
    $('[data-gallery]', root)?.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(slide + (e.key === 'ArrowRight' ? 1 : -1)); } });
    $('[data-zoom]', root)?.addEventListener('click', e => { const src = $('img', slides[slide]), dst = $('[data-large-image]', root); dst.src = src.currentSrc || src.src; dst.alt = src.alt; openDialog($('[data-image-dialog]', root), e.currentTarget); });
    $('[data-mechanism-toggle]', root)?.addEventListener('click', e => { const active = e.currentTarget.getAttribute('aria-pressed') !== 'true'; e.currentTarget.setAttribute('aria-pressed', String(active)); $('[data-mechanism]', root).classList.toggle('is-separated', active); });
    const config = JSON.parse($('[data-product-config]', root).textContent);
    const optionIndex = { set: config.optionNames.indexOf('Set'), color: config.optionNames.indexOf('Color'), size: config.optionNames.indexOf('Size') };
    if (Object.values(optionIndex).some(index => index < 0) || config.optionNames.length !== 3) return;
    const form = $('#DryloraProductForm', root), qty = $('[name="quantity"]', form);
    const fallback = $('[data-fallback]', form), id = $('[data-variant-id]', form), add = $('[data-add]', form), stickyAdd = $('[data-sticky-add]', root), status = $('[data-form-status]', root);
    const setNames = ['Complete Set', 'Everyday Set', 'Starter Set'];
    if (setNames.some(name => !config.variants.some(v => v.options[optionIndex.set] === name))) return;
    fallback.hidden = true; $('select', fallback).disabled = true; id.disabled = false; $('[data-options]', root).hidden = false;
    const read = type => $(`[name="drylora-${type}"]:checked`, root)?.value || '';
    const choose = (type, value) => $$(`[name="drylora-${type}"]`, root).forEach(input => input.checked = input.value === value);
    const requested = new URLSearchParams(location.search).get('variant');
    const initial = config.variants.find(v => String(v.id) === requested);
    if (initial) Object.keys(optionIndex).forEach(type => choose(type, initial.options[optionIndex[type]]));
    else {
      const requestedSet = new URLSearchParams(location.search).get('set');
      if (setNames.includes(requestedSet)) choose('set', requestedSet);
    }
    let selected = null, adding = false, ambiguous = false;
    function variantFor(set, color, size) { return config.variants.find(v => v.options[optionIndex.set] === set && v.options[optionIndex.color] === color && (!size || v.options[optionIndex.size] === size)); }
    const contents = {
      'Starter Set': '2 pairs of underwear + 1 removable, washable pad.',
      'Everyday Set': '4 pairs of underwear + 2 removable, washable pads + 1 washing bag.',
      'Complete Set': '6 pairs of underwear + 6 removable, washable pads + 2 washing bags + 1 wet bag.'
    };
    function update() {
      const set = read('set'), color = read('color'), size = read('size');
      const candidate = variantFor(set, color, size);
      selected = size ? candidate : null;
      id.value = selected?.id || '';
      const starter = variantFor('Starter Set', color, size);
      setNames.forEach(name => {
        const v = variantFor(name, color, size);
        $$('[data-set-price]', root).filter(n => n.dataset.setPrice === name).forEach(n => n.textContent = v ? money(v.price) : 'Unavailable');
        const multiple = name === 'Complete Set' ? 3 : name === 'Everyday Set' ? 2 : 1;
        const baseline = starter ? starter.price * multiple : 0;
        const saved = v ? baseline - v.price : 0;
        $$('[data-set-saving]', root).filter(n => n.dataset.setSaving === name).forEach(saving => {
          saving.hidden = saved <= 0;
          $('[data-saving-amount]', saving).textContent = money(baseline);

        });
        $$('[data-discount]', root).filter(n => n.dataset.discount === name).forEach(n => {
          n.hidden = saved <= 0;
          n.textContent = `${baseline ? Math.floor(saved / baseline * 100) : 0}% LESS* + FREE BAG GIFTS`;
        });
      });
      $('[data-color-label]', root).textContent = color;
      const count = set === 'Complete Set' ? 6 : set === 'Everyday Set' ? 4 : 2;
      $('[data-color-help]', root).textContent = color === 'Mixed' ? `${count / 2} Black + ${count / 2} Beige pairs. One size for your whole set.` : `All ${count} pairs in ${color}.`;
      if ($('[data-set-contents]', root)) $('[data-set-contents]', root).textContent = contents[set];
      if ($('[data-selected-set-label]', root)) $('[data-selected-set-label]', root).textContent = set;
      if ($('[data-gift-summary]', root)) {
        const complete = set === 'Complete Set', everyday = set === 'Everyday Set';
        $('[data-gift-summary]', root).textContent = complete ? '3 of 3 unlocked' : everyday ? '2 of 3 unlocked' : '1 of 3 unlocked';
        $('[data-gift="washing"]', root).classList.toggle('is-included', complete || everyday);
        $('[data-gift="wet"]', root).classList.toggle('is-included', complete);
        $('[data-gift-washing-label]', root).textContent = complete ? '2 FREE washing bags' : 'FREE washing bag';
        const washingCount = $('[data-gift-washing-count]', root);
        if (washingCount) washingCount.textContent = complete ? '×2' : '×1';
        $('[data-gift-washing-status]', root).textContent = complete || everyday ? 'Included in your set' : 'Choose Everyday or Complete to unlock';
        $('[data-gift-wet-status]', root).textContent = complete ? 'Included in your set' : 'Choose Complete to unlock';
        $$('[data-gift]', root).forEach(tile => {
          const unlocked = tile.classList.contains('is-included');
          tile.classList.toggle('is-locked', !unlocked);
          $('[data-gift-state]', tile).textContent = unlocked ? 'UNLOCKED' : 'LOCKED';
        });
      }
      $$('[name="drylora-size"]', root).forEach(input => { const v = variantFor(set, color, input.value); input.closest('label').classList.toggle('dr-unavailable', !v?.available); input.setAttribute('aria-label', `${input.value}${!v?.available ? ' — unavailable' : ''}`); });
      if (candidate) {
        qty.min = candidate.min || 1; qty.step = candidate.step || 1;
        if (candidate.max != null) qty.max = candidate.max; else qty.removeAttribute('max');
        // Keep the shopper's quantity unless the new variant's actual rules reject it.
        const current = Number(qty.value), min = Number(qty.min), step = Number(qty.step);
        if (!Number.isInteger(current) || current < min || (current - min) % step || (qty.max && current > Number(qty.max))) qty.value = String(min);
        if ($('[data-current-price]', root)) $('[data-current-price]', root).textContent = money(candidate.price * Number(qty.value));
        $('[data-sticky-price]', root).textContent = money(candidate.price * Number(qty.value));
      }
      const unavailable = !!size && !selected?.available;
      add.disabled = stickyAdd.disabled = adding || ambiguous || cartPending || cartUnconfirmed || unavailable || config.requiresPlan;
      const label = adding ? 'ADDING YOUR SET…' : ambiguous ? 'CHECK YOUR CART FIRST' : config.requiresPlan ? 'PURCHASE PLAN REQUIRED' : unavailable ? 'CURRENTLY UNAVAILABLE' : !size ? 'CHOOSE SIZE + GET MY SET' : 'GET MY SET + FREE EXTRAS';
      $$('[data-add-set]', root).forEach(button => {
        const variant = variantFor(button.dataset.addSet, color, size);
        button.disabled = adding || ambiguous || cartPending || cartUnconfirmed || config.requiresPlan || (!!size && !variant?.available);
        button.textContent = adding ? 'ADDING…' : ambiguous ? 'CHECK YOUR CART FIRST' : !!size && !variant?.available ? 'CURRENTLY UNAVAILABLE' : `ADD ${button.dataset.addSet.replace(' Set', '').toUpperCase()} TO CART →`;
      });
      $$('[data-quick-color]', root).forEach(select => select.value = color);
      $$('[data-quick-size]', root).forEach(select => select.value = size);
      $('[data-add-label]', root).textContent = label;
      $('[data-sticky-label]', root).textContent = label;
      $('[data-sticky-summary]', root).textContent = `${set} · ${color} · ${size || 'Choose your size'}`;
    }
    productStateUpdates.add(update);
    $$('[name^="drylora-"]', root).forEach(input => input.addEventListener('change', () => {
      status.textContent = ''; update();
    }));
    qty.addEventListener('change', update);
    $$('[data-choose-set]', root).forEach(button => button.addEventListener('click', () => { choose('set', button.dataset.chooseSet); update(); }));
    $$('[data-quick-color], [data-quick-size]', root).forEach(select => select.addEventListener('change', () => {
      choose(select.hasAttribute('data-quick-color') ? 'color' : 'size', select.value);
      $$('.dr-quick-status', root).forEach(n => n.textContent = '');
      update();
    }));
    $$('[data-add-set]', root).forEach(button => button.addEventListener('click', () => {
      if (adding || ambiguous || cartPending || cartUnconfirmed) return;
      choose('set', button.dataset.addSet); update();
      if (!read('size')) {
        const card = button.closest('.dr-compare-card');
        $('.dr-quick-status', card).textContent = 'Choose your size to add this set.';
        $('[data-quick-size]', card).focus(); return;
      }
      form.requestSubmit(add);
    }));
    form.addEventListener('submit', async event => {
      if (adding || ambiguous || cartPending || cartUnconfirmed) { event.preventDefault(); return; }
      if (!read('size')) { event.preventDefault(); status.textContent = 'Pick your size to make this set yours.'; const sizeField = $('.dr-size-field', root); sizeField.scrollIntoView({ behavior: 'smooth', block: 'center' }); $('[name="drylora-size"]', root).focus({ preventScroll: true }); return; }
      if (!selected?.available || config.requiresPlan) { event.preventDefault(); status.textContent = 'This selection is currently unavailable.'; return; }
      if (!form.reportValidity()) { event.preventDefault(); return; }
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (!beginCartMutation()) return;
      adding = true; update(); status.textContent = '';
      let accepted = false;
      try {
        const response = await fetch(routes.add, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (response.status >= 400 && response.status < 500) {
          const data = await response.json(); status.textContent = data.description || data.message || 'This selection could not be added. Check your options and try again.';
        } else {
          if (!response.ok) throw new Error('Unconfirmed cart response');
          const data = await response.json(); if (!data.id && !data.items) throw new Error('Unconfirmed cart response');
          accepted = true; status.textContent = 'Your set is in the cart.';
          openDialog($('[data-cart-dialog]'), add);
          await refreshCart('Your set is in. Ready when you are.', true);
        }
      } catch {
        if (!accepted) {
          ambiguous = true; status.textContent = 'We could not confirm the cart response. Check your cart before adding this set again.'; $('[data-cart-fallback]', root).hidden = false;
          await refreshCart('Check the cart contents before adding another set.', true);
        }
      } finally { adding = false; finishCartMutation(); }
    });
    const sticky = $('[data-sticky]', root);
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || window.scrollY < 250; }, { threshold: 0 });
    observer.observe(add);
    let scheduled = false;
    window.addEventListener('scroll', () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { const rect = add.getBoundingClientRect(); sticky.hidden = window.scrollY < 250 || (rect.bottom > 0 && rect.top < innerHeight); scheduled = false; }); }, { passive: true });
    update();
  }
  initProduct($('[data-drylora-product]'));
  document.addEventListener('shopify:section:load', e => initProduct($('[data-drylora-product]', e.target)));
})();


